<template>
  <div id="chart">
    <!--     <v-row no-gutters> -->
    <!--       <v-col cols="6" offset="6">
     
      </v-col>
      <v-col cols="12"> -->
    <!-- <v-checkbox x-small label="Povolit tooltip" v-model="tooltipEN" value="value" @change="changeTooltip()"></v-checkbox> -->
    <VueApexCharts id="chartX" ref="chartX" type="line" :height="height" :options="chartOptions" :series="series"></VueApexCharts>
    <!--       </v-col>
    </v-row> -->
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

import { inspectChartsColors } from "../../../colors.js";

export default {
  name: "ApexLineChart",
  components: {
    VueApexCharts,
  },
  props: {
    enabled: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Array,
      required: false,
    },
    height: {
      type: Number,
      required: false,
    },
    dark: {
      type: Boolean,
      required: false,
    },
  },
  data: () => ({
    /*  tooltipEN: false, */

    timer: null,
    shadeTo: "light",
    mode: "light",
    palette: "palette1",

    series: [
      {
        name: "Desktops",
        data: [],
      },
    ],

    chartOptions: {
      colors: inspectChartsColors,
      chart: {
        /*         height: 600, */
        type: "line",
        zoom: {
          type: "x",
          enabled: true,
          autoScaleYaxis: true,
        },
        toolbar: {
          autoSelected: "zoom",
        },
        animations: {
          enabled: false,
        },
      },
      /*       markers: {
        size: 0,
      }, */
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
        style: "hollow",
      },
      stroke: {
        curve: "straight",
        width: 1,
      },

      /*       title: {
        text: "Recorder",
        align: "center",
      }, */
      /*       yaxis: {
        tickAmount: 2,
      }, */
      xaxis: {
        labels: {
          show: true,
        },
        tickAmount: 5,
      },
      grid: {
        /*         row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        }, */
      },
      theme: {
        mode: "light",
        palette: "palette1",
        monochrome: {
          enabled: false,
          color: "#255aee",
          shadeTo: "light",
          shadeIntensity: 0.65,
        },
      },
      /*       tooltip: {
        enabled: false,
      }, */
    },
  }),
  mounted() {
    this.timer = setInterval(() => {
      if (this.enabled === true) {
        this.updateChart();
      }
    }, 100);
  },
  methods: {
    updateChart() {
      let obj;

      this.series = [];

      for (let index = 0; index < this.data.length; index++) {
        obj = {
          name: this.data[index].name,
          data: this.data[index].data,
        };

        this.series.push(obj);
      }

      //this.$refs.chart.updateSeries(series);
    },
    changeTooltip() {
      /*       if (this.tooltipEN === true) {
        this.chartOptions = {
          ...this.chartOptions,
          ...{
            tooltip: {
              enabled: true,
            },
          },
        };
      } else {
        this.chartOptions = {
          ...this.chartOptions,
          ...{
            tooltip: {
              enabled: false,
            },
          },
        };
      } */
    },
    updateTheme() {
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          theme: {
            mode: this.mode,
            palette: this.palette,
            monochrome: {
              enabled: false,
              color: "#255aee",
              shadeTo: this.shadeTo,
              shadeIntensity: 0.65,
            },
          },
        },
      };
    },

    /*     setPalette(e) {
      this.palette = e.target.value;
      this.updateTheme();
    }, */

    /*         tooltip: {
      enabled: true,
      enabledOnSeries: undefined,
      shared: true,
      followCursor: false,
      intersect: false,
      inverseOrder: false,
      custom: undefined,
      fillSeriesColor: false,
      theme: false,
      style: {
        fontSize: '12px',
        fontFamily: undefined
      },
      onDatasetHover: {
          highlightDataSeries: false,
      },
      x: {
          show: true,
          format: 'dd MMM',
          formatter: undefined,
      },
      y: {
          formatter: undefined,
          title: {
              formatter: (seriesName) => seriesName,
          },
      },
      z: {
          formatter: undefined,
          title: 'Size: '
      },
      marker: {
          show: true,
      },
      items: {
         display: flex,
      },
      fixed: {
          enabled: false,
          position: 'topRight',
          offsetX: 0,
          offsetY: 0,
      },
  } */

    /* this.chartOptions = {
  ...this.chartOptions,
  ...{
    animations: {
          enabled: false,
          easing: "linear",
          dynamicAnimation: {
            speed: 1000,
          },
        },
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
  }
}

zoom: {
          type: "x",
          enabled: true,
          autoScaleYaxis: true,
        },
        toolbar: {
          autoSelected: "zoom",
        },
        animations: {
          enabled: false,
        },

this.chartOptions = {
  ...this.chartOptions,
  ...{
    animations: {
          enabled: false,
          easing: "linear",
          dynamicAnimation: {
            speed: 1000,
          },
        },
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
  }
} */

    setStroke(e) {
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          stroke: {
            curve: "straight",
            width: e.target.value,
          },
        },
      };
    },
    setTheme() {
      if (this.dark === true) {
        this.shadeTo = "dark";
        this.mode = "dark";
        this.updateTheme();
      } else {
        this.shadeTo = "light";
        this.mode = "light";
        this.updateTheme();
      }
    },
  },
  /*   mounted() {
    this.setTheme();
  }, */
  beforeDestroy() {
    if (this.timer != null) {
      clearInterval(this.timer);
    }
  },
  /*   watch: {
    data: function() {
      this.updateChart();
    },
    dark: function() {
      this.setTheme();
    },
  }, */
};
</script>
